// Theme initialisation: sets `data-theme` on <html> synchronously before
// first paint to prevent a flash of the wrong colour scheme.
// Compiled by rollup.config.mjs to:
//   packages/natama_theme/Resources/Public/JavaScript/theme-init.min.js

const THEME_STORAGE_KEY = 'natama-theme';

((): void => {
	try {
		const stored = localStorage.getItem(THEME_STORAGE_KEY);
		const prefersDark =
			window.matchMedia != null &&
			window.matchMedia('(prefers-color-scheme: dark)').matches;
		document.documentElement.setAttribute(
			'data-theme',
			stored ?? (prefersDark ? 'dark' : 'light'),
		);
	} catch {
		document.documentElement.setAttribute('data-theme', 'light');
	}
})();
